import { Stack, Tooltip } from '@cmg/design-system';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../common/util/routeFactory';
import type { CalendarGridCustomCellRendererProps } from '../../CalendarGrid.model';
import type { Value } from './DemandCellRenderer.model';
import { hasMultipleIoIs } from './DemandCellRenderer.model';

export type DemandCellRendererProps = CalendarGridCustomCellRendererProps<Value>;

export const DemandCellRenderer: React.FC<DemandCellRendererProps> = ({
  data,
  value,
  valueFormatted,
}) => {
  const withTooltip = hasMultipleIoIs(value);

  if (isNil(data) || isEmpty(value)) {
    return <React.Fragment>{valueFormatted}</React.Fragment>;
  }

  return (
    <Tooltip
      variant="info"
      placement="top"
      title={
        withTooltip && (
          <Stack>
            {value.map(ioi => (
              <span key={ioi}>{ioi}</span>
            ))}
          </Stack>
        )
      }
    >
      <Link to={routeFactory.ioi.getUrlPath({ id: data.id })}>{valueFormatted}</Link>
    </Tooltip>
  );
};
